<template>
    <div class="modal" v-show="value">
        <div class="modal__content">
            <div class="modal__header">
                <div class="modal__header-title text-light">
                    <span v-if="title">{{ title }}</span>
                </div>
                <div>
                    <span class="close" @click="close()">&times;</span>
                </div>
            </div>
            <div class="modal__body">
                <p><span v-if="title">{{ text }}</span></p>
            </div>
            <div class="modal__footer">
                <div class="modal__footer__buttons">
                    <button class="btn" @click="close()">{{ $t('common.close') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'alert-modal',
        props: {
            value: {
                required: true
            },
            title: {
                required: false
            },
            text: {
                required: false
            }
        },
        methods: {
            close() {
                this.$emit("input", !this.value);
            }
        }
    };
</script>
